import { render, staticRenderFns } from "./AuthNav.vue?vue&type=template&id=49db63bc&scoped=true"
import script from "./AuthNav.vue?vue&type=script&lang=js"
export * from "./AuthNav.vue?vue&type=script&lang=js"
import style0 from "./AuthNav.vue?vue&type=style&index=0&id=49db63bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49db63bc",
  null
  
)

export default component.exports